import React from "react";

import { Routes, Route } from "react-router-dom";


import Profile from "../pages/profile/Profile";


import Users from "../pages/users/Users";


import NotFound from "../pages/notFound/NotFound";

import Notifications from "../pages/notifications/Notifications";

import Home from '../pages/home/Home';
import Administrators from "../pages/administrators/Administrators";
import Products from "../pages/products/Products";
import Categories from "../pages/categories/Categories";
import Orders from "../pages/orders/Orders";
import Invoices from "../pages/invoices/Invoices";
import Sales from "../pages/sales/Sales";
const MyRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home/>} />
     
      <Route path="/profile" element={<Profile />} />

      <Route path="/users" element={<Users />} />
      <Route path="/products" element={<Products />} />
      <Route path="/administrators" element={<Administrators />} />

      <Route path="/notifications" element={<Notifications />} />
      <Route path="/categories" element={<Categories />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/invoices" element={<Invoices/>}/>
      <Route path="/sales" element={<Sales/>}/>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default MyRoutes;
